// src/utils/normalize.js

export function normalizeKey(input) {
  if (!input || typeof input !== 'string') return '';

  const canonicalModes = {
    major: 'major',
    maj: 'major',
    minor: 'minor',
    min: 'minor',
    dorian: 'dorian',
    dor: 'dorian',
    mixolydian: 'mixolydian',
    mix: 'mixolydian',
  };

  const rootRegex = /^(c#|cb|c|d#|db|d|e#|eb|e|f#|fb|f|g#|gb|g|a#|ab|a|b#|bb|b)/i;
  const lowered = input.trim().toLowerCase().replace(/\s+/g, '');

  const rootMatch = lowered.match(rootRegex);
  if (!rootMatch) return input.trim();

  const rawRoot = rootMatch[0];
  const rest = lowered.slice(rawRoot.length);

  const rootMap = {
    'bb': 'Bb', 'ab': 'Ab', 'eb': 'Eb', 'db': 'Db', 'gb': 'Gb', 'cb': 'Cb', 'fb': 'Fb',
    'f#': 'F#', 'c#': 'C#', 'g#': 'G#', 'd#': 'D#', 'a#': 'A#', 'e#': 'E#', 'b#': 'B#',
    'b': 'B', 'a': 'A', 'c': 'C', 'd': 'D', 'e': 'E', 'f': 'F', 'g': 'G'
  };

  const root = rootMap[rawRoot] || rawRoot.toUpperCase();

  if (!rest) return `${root} major`;

  const canonicalMode = canonicalModes[rest];
  if (canonicalMode) {
    return `${root} ${canonicalMode}`;
  }

  return `${root} ${rest.toLowerCase()}`;
}


export function normalizeType(raw) {
  if (!raw) return '';
  return raw
    .trim()
    .toLowerCase()
    .split(' ')
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}


export function keyRoot(normalizedKey) {
  const raw = (normalizedKey || '').trim();

  // Match longest valid accidental-based root first
  const match = raw.match(/^(C#|Db|D#|Eb|E#|Fb|F#|Gb|G#|Ab|A#|Bb|B#|Cb|C|D|E|F|G|A|B)/i);

  return match ? match[1].replace(/^\w/, c => c.toUpperCase()) : '';
}

const genreOverrides = {
  'old time': 'Old-Time',
  'bluegrass': 'Bluegrass',
  'irish': 'Irish',
  'r&b': 'R&B',
  'singer songwriter': 'Singer-Songwriter',
};

export function normalizeGenre(genre) {
  if (!genre) return '';
  const clean = genre.trim().toLowerCase();
  return genreOverrides[clean] || clean.replace(/\b\w/g, c => c.toUpperCase());
}


export const normalizeTag = (tag) => tag.trim().toLowerCase();

export const normalizeTagsArray = (tags) => {
  return [...new Set(tags.map(normalizeTag).filter(tag => tag.length > 0))];
};
